export const listHideCarBrand: string[] = [
  "ed70991f-411c-4ac0-8ae4-0c7d66427e59",
  "06df3ccf-b96f-4c95-98fb-801b25295a66",
  "b7b77302-86a5-4d13-a621-d25bb9c48569",
  "f31e885d-dfc5-403c-beb2-da3d0a20c9ce",
  "20d8df48-232c-4711-9eac-b6fbf5d67253",
];

export const IS_UPDATING = "DANG CAP NHAT";
export const IS_UPDATING_VI_CODE = "ĐANG CẬP NHẬT";
export const OTHER: string = "other";
